import type { ReactNode } from 'react';
import { Spinner } from './Spinner';
import { Button } from './Button';

type Kind = 'loading' | 'empty' | 'error';

interface PageStateProps {
  kind: Kind;
  title?: string;
  message?: ReactNode;
  onRetry?: () => void;
}

const DEFAULT_TITLE: Record<Kind, string> = {
  loading: 'Loading',
  empty: 'Nothing here yet',
  error: 'Something went wrong',
};

/**
 * Standard loading / empty / error presentation so every screen handles the
 * states required by docs/UI_SPEC.md section 6.
 */
export function PageState({ kind, title, message, onRetry }: PageStateProps) {
  return (
    <div
      className={`ne-page-state ne-page-state--${kind}`}
      role={kind === 'error' ? 'alert' : 'status'}
    >
      {kind === 'loading' ? <Spinner /> : null}
      <span className="ne-page-state__title">{title ?? DEFAULT_TITLE[kind]}</span>
      {message ? <span>{message}</span> : null}
      {kind === 'error' && onRetry ? (
        <Button variant="secondary" onClick={onRetry}>
          Retry
        </Button>
      ) : null}
    </div>
  );
}
